import React from 'react';
import styles from './UploadFile.less';
import { Button } from 'antd';

class UploadFile extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { fileName, onChange, callback, onBeforeUpload } = this.props;

    const handleChange = e => {
      onChange(e.target.files[0] || '');
      if (callback) {
        callback(e.target.files[0]);
      }
    };

    return (
      <Button className={styles.uploadFile} type="primary">
        <input type="file" onChange={handleChange} />
        {fileName || '选择更新包文件'}
      </Button>
    );
  }
}

export default UploadFile;



// WEBPACK FOOTER //
// ./src/components/UploadFile.js